"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _connectToStores = _interopRequireDefault(require("fluxible-addons-react/connectToStores"));

var _client = require("@audacious/client");

var _page = require("@audacious/components/lib/components/page");

var _panels = _interopRequireDefault(require("./panels"));

var _reports = _interopRequireDefault(require("./reports"));

var _reviewPanelsPage = _interopRequireDefault(require("./review-panels-page"));

require("./home-page.css");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var PANELS_TAB = 'panels-tab';
var REPORTS_TAB = 'reports-tab';

var _ref =
/*#__PURE__*/

/*#__PURE__*/
_react.default.createElement(_reviewPanelsPage.default, null);

var HomePage = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(HomePage, _React$Component);

  var _super = _createSuper(HomePage);

  function HomePage(props) {
    var _this;

    (0, _classCallCheck2.default)(this, HomePage);
    _this = _super.call(this, props);
    _this.state = {
      pageContentTab: PANELS_TAB
    };
    _this.handlePageContentTabChange = _this.handlePageContentTabChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(HomePage, [{
    key: "handlePageContentTabChange",
    value: function handlePageContentTabChange(value) {
      this.setState({
        pageContentTab: value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var pageContentTab = this.state.pageContentTab;
      var _this$props = this.props,
          reviewImportedPanel = _this$props.reviewImportedPanel,
          applicationName = _this$props.applicationName,
          panels = _this$props.panels,
          loadingPanels = _this$props.loadingPanels;

      if (reviewImportedPanel) {
        return _ref;
      }

      var contentRender = null;

      if (pageContentTab === PANELS_TAB) {
        contentRender = /*#__PURE__*/_react.default.createElement(_panels.default, {
          panels: panels,
          loadingPanels: loadingPanels
        });
      } else if (pageContentTab === REPORTS_TAB) {
        contentRender = /*#__PURE__*/_react.default.createElement(_reports.default, {
          panels: panels
        });
      }

      return /*#__PURE__*/_react.default.createElement(_client.AuthenticatedPage, {
        id: "missing-persons-main-page",
        pageName: "Missing Persons",
        variant: "grey",
        hideTitle: true,
        hideFooter: true
      }, /*#__PURE__*/_react.default.createElement(_page.PageTitle, {
        pageName: applicationName,
        selectedTab: pageContentTab,
        onTabSelect: this.handlePageContentTabChange,
        tabs: [{
          id: PANELS_TAB,
          heading: 'Panels'
        }, {
          id: REPORTS_TAB,
          heading: 'Reports'
        }]
      }), /*#__PURE__*/_react.default.createElement(_page.PageContainer, {
        asCard: true,
        allowScroll: true,
        className: "missing-persons-main-content"
      }, contentRender));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    value: // @ts-ignore
    function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return HomePage;
}(_react.default.Component);

HomePage.defaultProps = {
  panels: []
};

var _default = (0, _connectToStores.default)(HomePage, ['MissingPersonsStore', 'ApplicationContext'], function (context) {
  var missingPersonsStore = context.getStore('MissingPersonsStore');

  var _missingPersonsStore$ = missingPersonsStore.getState(),
      reviewImportedPanel = _missingPersonsStore$.reviewImportedPanel,
      panels = _missingPersonsStore$.panels,
      loadingPanels = _missingPersonsStore$.loadingPanels;

  var applicationContextStore = context.getStore('ApplicationContext');
  return {
    reviewImportedPanel: reviewImportedPanel,
    panels: panels,
    loadingPanels: loadingPanels,
    applicationName: applicationContextStore.getApplicationName()
  };
});

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(PANELS_TAB, "PANELS_TAB", "/builds/pulse-platform/pulse-missingperson-web-application/src/components/home-page/home-page.jsx");
  reactHotLoader.register(REPORTS_TAB, "REPORTS_TAB", "/builds/pulse-platform/pulse-missingperson-web-application/src/components/home-page/home-page.jsx");
  reactHotLoader.register(HomePage, "HomePage", "/builds/pulse-platform/pulse-missingperson-web-application/src/components/home-page/home-page.jsx");
  reactHotLoader.register(_default, "default", "/builds/pulse-platform/pulse-missingperson-web-application/src/components/home-page/home-page.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();